import DirectionStudents from './direction-students'

export default DirectionStudents
